// extracted by mini-css-extract-plugin
module.exports = {"root":"CommunityGuidelines-root-2ce6c8f2e8f60dee991dd06ccce1b424"};